// Styles
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";

// Vuetify
import { createVuetify } from "vuetify";
import i18n from "./i18n";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import { VDateInput } from "vuetify/labs/VDateInput";
import { VTreeview } from "vuetify/labs/VTreeview";
import { watchEffect } from "vue";
import ptBRVuetify from "../locales/pt-BR/vuetify.json";
import enUSVuetify from "../locales/en-US/vuetify.json";
import esESVuetify from "../locales/es-ES/vuetify.json";

const messages = {
    "pt-BR": ptBRVuetify,
    "en-US": enUSVuetify,
    "es-ES": esESVuetify,
};

const vuetify = createVuetify({
    components: {
        VDateInput,
        VTreeview,
        ...components,
    },
    directives,

    locale: {
        locale: i18n.global.locale.value, // pega o idioma atual do i18n
        messages,
        adapter: {
            t: (key, ...params) => {
                const locale = i18n.global.locale.value;
                return messages[locale][key] ?? key;
            },
        },
    },
    date: {
        locale: i18n.global.locale.value,
    },
});

export default vuetify;
